export class CoordonneesGps{
    public latitude : number = 0;
    public longitude : number = 0;
    constructor() { }
}
